import { StackChildren } from '@doordash/design-language'
import styled from 'styled-components'

export const StyledPicture = styled.picture`
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
`

export const CenteredContent = styled(StackChildren)`
  text-align: center;
`
export const UploadPreview = styled.img`
  max-height: 45vh;
  max-width: 90%;
`
